module.exports = __webpack_public_path__ + "img/01-MyTip-04.76d7ff85.png";